import { useNavigate, useParams } from "react-router-dom";

export default function withRouterParamsHook(Component) {
    return function WrappedComponent(props) {
        const params = useParams();
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} params={params} />;
    }
}